import React from "react"
import { GiRabbit } from "react-icons/gi"
import "bootstrap/dist/css/bootstrap.min.css"

const Privacy = () => {
  return (
    <div>
      <div className="container my-5">
        <div className="my-5">
          <h1>Privacy Policy</h1>
          <hr />
          <h2 className="mt-3">Data gathered by this website</h2>
          <p>We do not currently store any information about individuals who use this website. </p>

          <h2>Our service partners</h2>
          <p>We use the following third-party service providers:</p>
          <ul>
            <li>Mailchimp (The Rocket Science Group, LLC), which we use to manage email marketing subscriber lists and
              send
              emails to our subscribers. <a href="https://mailchimp.com/legal/privacy/" target="_blank"
                                            rel="noopener noreferrer">Read
                their privacy policy</a>.
            </li>
          </ul>
        </div>

      </div>
      <h3 className="text-center">&#8594; <a href="/" className="text-decoration-none text-black-50"><GiRabbit />
      </a>&#8592;
      </h3>
    </div>
  )
}

export default Privacy